// extracted by mini-css-extract-plugin
module.exports = {"container":"SnsLinkIconGroup_container__26qBa","link":"SnsLinkIconGroup_link__2WG0R","sending":"SnsLinkIconGroup_sending__2Fy7h"};